import { PROFILE } from '@/shared/config/routes';
import { useIsAuth, useUser } from '@/entities/user/session';
import { Avatar, Group, rem, Text, UnstyledButton } from '@mantine/core';
import IconChevronRight from '@tabler/icons-react/dist/esm/icons/IconChevronRight.mjs';
import { Link } from 'react-router-dom';
import classes from './user-button.module.css';

export const UserButton = () => {
  const user = useUser();

  const isAuth = useIsAuth();

  if (!isAuth) return null;
  return (
    <UnstyledButton
      className={classes.user}
      p={'md'}
      component={Link}
      to={PROFILE}
    >
      <Group>
        <Avatar
          autoContrast
          radius={'xl'}
          color={'initials'}
          name={
            user?.name && user?.surname
              ? `${user?.surname} ${user?.name}`
              : null
          }
        />
        <div style={{ flex: 1, minWidth: 0 }}>
          <Text size='sm' fw={500} style={{ overflowWrap: 'anywhere' }}>
            {user?.surname} {user?.name}
          </Text>

          <Text c='dimmed' size='xs' style={{ overflowWrap: 'anywhere' }}>
            {user?.login}
          </Text>
        </div>

        <IconChevronRight
          style={{ width: rem(14), height: rem(14) }}
          stroke={1.5}
        />
      </Group>
    </UnstyledButton>

    //   </Menu.Target>
    //   <Menu.Dropdown>
    //     <Menu.Item onClick={() => logout()}>
    //       {t('header:user.logout')}
    //     </Menu.Item>
    //   </Menu.Dropdown>
    // </Menu>
  );
};